import {MAX_VIDEO_MB} from '../../../videoSource';
import {createText} from '../../../createText';
import {
  LibraryFile,
  isDocumentName,
  isMp4LibraryFile,
  isMp4Upload,
} from '../createOptions';

const MB = 1024 * 1024;

interface Limits {
  /** Videos can be the source: MP4s are taken next to documents. */
  videos: boolean;
  /** The server's document limit; videos keep their own. */
  maxDocumentMb: number;
}

/** Why a file picked from the computer can't be the source, or null when it can. */
export function uploadProblem(
  file: File,
  {videos, maxDocumentMb}: Limits,
): string | null {
  const isVideo = videos && isMp4Upload(file);
  if (!isVideo && !isDocumentName(file.name))
    return videos
      ? createText.uploadDocumentOrVideo
      : createText.uploadDocument;
  if (isVideo && file.size > MAX_VIDEO_MB * MB)
    return createText.videoTooLarge(MAX_VIDEO_MB);
  if (!isVideo && file.size > maxDocumentMb * MB)
    return createText.documentTooLarge(maxDocumentMb);
  return null;
}

/** Why a library file can't be the source, or null when it can. */
export function libraryFileProblem(
  file: LibraryFile,
  {videos, maxDocumentMb}: Limits,
): string | null {
  const isVideo = videos && isMp4LibraryFile(file);
  if (!isVideo && !isDocumentName(file.fileName))
    return videos
      ? createText.chooseDocumentOrVideo
      : createText.chooseDocument;
  // The library lists sizes in MB; its files are held to the same limits as uploads.
  if (isVideo && (file.fileSize ?? 0) > MAX_VIDEO_MB)
    return createText.videoTooLarge(MAX_VIDEO_MB);
  if (!isVideo && (file.fileSize ?? 0) > maxDocumentMb)
    return createText.documentTooLarge(maxDocumentMb);
  return null;
}
